export default __webpack_public_path__ + "static/media/righteye.1a7c639a.svg";